import React from 'react';
import UserTable from '../features/Users/components/UserTable';

import { Button, Stack, Grid, TextField, MenuItem, Breadcrumbs, Link, Typography } from '@mui/material';
import { PersonAddRounded, VpnKeyRounded } from '@mui/icons-material';
import SearchBar from '../features/Search/components/SearchBar';
import { variants } from '../variants/variants';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSelectedFeatures, setSidebar } from '../features/Users/userSlice';

const Users = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleOpenPermissions = () => {
    dispatch(setSidebar({ value: true }));
    navigate('permissions');
  };
  return (
    <Grid container sx={{ display: 'flex', flexDirection: 'column', p: 2, px: 0 }}>
      <Stack direction={'row'} alignItems={'center'} sx={{ mt: -2 }}>
        {/* <TextField
          select
          defaultValue={'ALL'}
          size="small"
          sx={{
            width: '200px',
            '.MuiOutlinedInput-root > fieldset': {
              borderRadius: '15px',
            },
          }}
        >
          {['ALL', 'USER', 'ADMIN'].map((option, index) => (
            <MenuItem
              key={index}
              value={option}
              sx={{
                fontSize: variants.BODY,
              }}
            >
              {option}
            </MenuItem>
          ))}
        </TextField>
        <SearchBar
          sx={{
            mx: 1,
            borderBottom: 0,
            '.MuiOutlinedInput-root > fieldset': {
              borderRadius: '15px',
            },
          }}
        /> */}
        <Button
          variant='outlined'
          size='small'
          sx={{ ml: 'auto', borderRadius: '10px', fontSize: variants.TINY }}
          startIcon={<VpnKeyRounded />}
          onClick={handleOpenPermissions}
        >
          Permission manager
        </Button>
      </Stack>
      <UserTable />
    </Grid>
  );
};

export default Users;
